import {Injectable} from '@angular/core';
import {AbstractService} from './abstract.service';
import {ApiVersion} from '../constants/apis';
import {AuditLog, AuditLogFilterTypes, AuditLogFilterValues} from '../models/audit-log.model';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PolicyType} from '../constants/retention-constants';

@Injectable({
  providedIn: 'root'
})
export class AuditLogService extends AbstractService {

  constructor(private http: HttpClient) {
    super();
  }

  list(limit: number, offset: number, filters: AuditLogFilterValues, retentionType: PolicyType): Observable<AuditLog[]> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'audit/list');
    const params = new HttpParams()
      .set('limit', String(limit))
      .set('offset', String(offset))
      .set('retentionType', retentionType);
    return this.http.post<AuditLog[]>(url, filters, {params: params});
  }

  count(filters: AuditLogFilterValues, retentionType: PolicyType): Observable<{ auditLogCount: number }> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'audit/count');
    const params = new HttpParams().set('retentionType', retentionType);
    return this.http.post<{ auditLogCount: number }>(url, filters, {params: params});
  }

  getFilterValues(filterName: string, retentionType: PolicyType): Observable<AuditLogFilterTypes> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'audit/filter-values');
    const params = new HttpParams()
      .set('filterName', filterName)
      .set('retentionType', retentionType);
    return this.http.get<AuditLogFilterTypes>(url, {params: params});
  }

  convertAuditLogFiltersToHttpParams(filters: AuditLogFilterValues): HttpParams {
    let httpParams = new HttpParams();
    Object.keys(filters).forEach(k => {
      if (filters[k]) {
        httpParams = httpParams.set(k, filters[k]);
      }
    });

    return httpParams;
  }
}
